const shortRegex = /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/;
const longRegex = /^(0x[a-zA-Z0-9]{8})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/;

export function shortenAddress(address: string, len: 'sm' | 'lg' = 'sm') {
  const match = address.match(len === 'sm' ? shortRegex : longRegex);

  return match ? `${match[1]}…${match[2]}` : address;
}
